// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import AlertContainer from '../../alert/container/AlertContainer';
import { Route, Switch } from 'react-router';
import routes from '../../../routes';
import Page from '../../../Page';
import NotFound from '../../error/components/404/404';
import ReceptionContainer from '../recepetion/container/ReceptionContainer';
import { PrivateRoute } from '../../../router';

import style from './Courier.scss';

import type { User } from '../../../entities';

type Props = {
  user?: User;
  authenticated?: boolean;
};

export default class Courier extends Component<Props> {
  render() {
    const { user, authenticated } = this.props;
    return (
      <Fragment>
        <section className={style.alertWrap}>
          <AlertContainer showId={['courier-reception']}/>
        </section>
        <Switch>
          <PrivateRoute exact path={routes.COURIER.children.RECEPTION.routePath}
                        component={ReceptionContainer}
                        user={user} authenticated={authenticated}/>
          <Route render={props => <Page name={routes.NOT_FOUND.name}><NotFound {...props}/></Page>}/>
        </Switch>
      </Fragment>
    );
  };
}

Courier.propTypes = {
  user: PropTypes.object,
  authenticated: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/courier/components/Courier.jsx